import React from 'react'
import { Link } from "react-router-dom";
import "./component.scss"
import Linkedin from "../Images/linkedin.png"
import social from "../Images/social.png"
import git from "../Images/githubIcon.png"
import Dropdown from "../Images/dropdown.png"
import $ from "jquery"
export default function Menu() {
  return (
  
  <div className="flexbox-Menu">
    <div className='menuflex'>
    <Link  to="/"><button className="menubutton1">Home</button></Link>
    <Link style={{textDecoration: "none"}} to="/Projects"><button className="menubutton1">Projects</button></Link>
    </div>
    <button style={{border: "none",background:"none"}} onClick={()=>{$(".menuflex1").toggle()}} className="dropdown" ><img className="dropdownimg" src={Dropdown} alt=""/></button>
    <a href='https://www.linkedin.com/in/abiboulaye-diagne-84884225b/'><div className="menubutton3"><img className="menubuttonimg" src={Linkedin} alt=""/></div></a>
    <a href='https://codify.fly.dev/'><div className="menubutton3"><img className="menubuttonimg" src={social} alt=""/></div></a>
    <a href='https://www.github.com/hackerbibou'><div className="menubutton3"><img className="menubuttonimg" src={git} alt=""/></div></a>
    
    <Link className='lets' style={{textDecoration: "none"}} to="/Contactme"><button className="menubutton2">Let's Connect</button></Link>
  </div>

  )
}
